<ng-container *ngIf="quoteForm && bDialogLoaded">
  <div [formGroup]="quoteForm">
    <header>
      <div class="d-flex dialog-header">
        <h3 class="dialog-title" translate>
          <div *ngIf="!isTemplate">
            <fa-icon [icon]="['fas', 'plus-circle']" transform="shrink-3" class="dialog-title"></fa-icon>
            {{ strViewType + '_quote' | translate }} {{ strQuoteNumber }}
          </div>

          <div *ngIf="isTemplate" class="mb-1">
            <input *ngIf="editText"  #quotename (focusout)="focusInput(false)" class="form-control" id="quote_name" name="quote_name" formControlName="quote_name"/>
            <div *ngIf="!editText" class="dialog-title">
              <span (click)="focusInput(true)">&nbsp;{{ quoteForm.controls['quote_name'].value }}</span>
              <fa-icon [icon]="['fas', 'pencil']" transform="shrink-3" class="ml-2"></fa-icon>
            </div>

          </div>
        </h3>
        <div class="ml-auto">

          <ul class="list-inline pull-right">
            <li class="list-inline-item">
              <div [ngClass]="(increasedProfit) ? 'profit-increase' : 'profit-decrease'">
                <span class="pl-1">{{ totalProfit | currency }} ({{ profitPercentage }}%)</span>
              </div>
            </li>

            <ng-container *ngIf="strViewType === 'edit' && this.strModule !== 'quote_templates'">
              <li class="list-inline-item">
                <form-templates-generator module-name="quotes" [module-id]="quoteId"></form-templates-generator>
              </li>

              <li *ngIf="data['quote']['is_primary'] === false; else removePrimary" class="list-inline-item">
                <button type="button" (click)="setAsPrimary(true)" class="btn btn-primary">
                  <fa-icon [icon]="['fas', 'crown']"></fa-icon>
                  <span class="pl-1">{{ 'set_primary' | translate }}</span>
                </button>
              </li>

              <ng-template #removePrimary>
                  <li class="list-inline-item">
                    <button type="button" (click)="setAsPrimary(false)" class="btn btn-primary">
                      <fa-icon [icon]="['fas', 'crown']"></fa-icon>
                      <span class="pl-1">{{ 'unset_primary' | translate }}</span>
                    </button>
                  </li>
              </ng-template>

            </ng-container>


            <li *ngIf="!isTemplate" class="list-inline-item">
              <form-real-time-pdf-preview
                [disabled]="bSubmitted || (whenInProgress$ | async)"
                (click)="onPreview()"
                [trigger-event]="realTimePreviewTemplate.asObservable()"
                (onComplete)="whenInProgress$.next(false)">
              </form-real-time-pdf-preview>
            </li>

            <li class="list-inline-item" *ngIf="! isTemplate">
              <button  (click)="saveTemplateName()" class="btn btn-primary" [disabled]="bSubmitted">
                <ng-container *ngIf="bHideTemplateButton == null || bHideTemplateButton === true">
                  <fa-icon *ngIf="!bShowLoader" [icon]="['fas', 'file-plus']"></fa-icon>
                  <fa-icon *ngIf="bShowLoader" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
                </ng-container>
                <span class="pl-1">{{ 'save_template' | translate }}</span>
              </button>
            </li>

            <li *ngIf="!isTemplate" class="list-inline-item">
              <form-templates-save-and-preview-btn
                [disabled]="bSubmitted"
                (click)="saveAndPreview()"
                [trigger-event]="previewTemplate.asObservable()">
              </form-templates-save-and-preview-btn>
            </li>

            <ng-container *ngIf="!isTemplate">
              <li class="list-inline-item">
                <button *ngIf="!bSubmitted && bHideTemplateButton == null || bHideTemplateButton === false"
                  (click)="save()" class="btn btn-primary" [disabled]="bSubmitted">
                  <fa-icon *ngIf="!bShowLoader" [icon]="['fas', 'save']"></fa-icon>
                  <fa-icon *ngIf="bShowLoader" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
                  <span class="pl-1">{{ 'save' | translate }}</span>
                </button>
              </li>
            </ng-container>

            <li *ngIf="isTemplate" class="list-inline-item">
              <button *ngIf="isTemplate" (click)="save()" class="btn btn-primary" [disabled]="bSubmitted">
                <ng-container *ngIf="bHideTemplateButton == null || bHideTemplateButton === true">
                  <fa-icon *ngIf="!bShowLoader" [icon]="['fas', 'file-plus']"></fa-icon>
                  <fa-icon *ngIf="bShowLoader" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
                </ng-container>
                <span  class="pl-1">{{ 'save' | translate }}</span>
              </button>
            </li>

            <li class="list-inline-item">
              <button type="button" (click)="cancelDialog()" class="btn btn-danger">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                <span class="pl-1">{{ 'close' | translate }}</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <hr />
    </header>


    <ul class="nav nav-tabs" id="quoteTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" (click)="closeDropdown()" id="quote-editor-tab" data-toggle="tab" href="#quote-editor" role="tab" aria-controls="quote-editor" aria-selected="false">{{ 'quote' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="closeDropdown()" id="cover-letter-tab" data-toggle="tab" href="#cover-letter" role="tab" aria-controls="cover-letter" aria-selected="false">{{ 'cover_letter' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="closeDropdown()" id="documents-tab" data-toggle="tab" href="#documents" role="tab" aria-controls="documents" aria-selected="true">{{ 'documents' | translate }}</a>
      </li>
    </ul>
    <div class="tab-content" id="quoteTabContent" style="max-height: 70vh; overflow-y: auto; overflow-x: hidden;">
      <div class="tab-pane fade show active" id="quote-editor" role="tabpanel" aria-labelledby="quote-editor-tab">
        <div class="row">
          <div *ngFor="let fields of arNgSelectFields | keyvalue" class="col-lg-3 mt-3">
            <label style="font-size: 14px" for="{{ fields.value['name'] }}">{{ fields.value['placeholder'] | translate }}</label>
            <ng-select
              [items]="fields.value['obv'] | async"
              [typeahead]="fields.value['typehead']"
              [loading]="fields.value['loader']"
              [hideSelected]="true"
              [clearable]="true"
              [ngModelOptions]="{standalone: true}"
              bindLabel="text"
              bindValue="id"
              (open)="triggerSubject(fields.value['typehead'])"
              (change)="onValueChange($event, fields.value)"
              [(ngModel)]="fields.value['value']"
              [id]="fields.value['name']"
              [name]="fields.value['name']"
              (ngModelChange)="markAsDirty()"
              [groupBy]="(fields.key == 'contacts') ? 'group_name' : ''">
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">{{ item.text | translate }}</span>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item">
                  {{ ( item.group_name | translate ) }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span *ngIf="!item.role" class="value-text"> {{ item.text | translate }}</span>
                  <span *ngIf="item.role" class="value-text"> {{ item.text | translate }} - {{ item.role | translate }}</span>
                </ng-template>
            </ng-select>
          </div>

          <div class="col-lg-3 mt-3">
            <app-edit-field [item]="objQuotesField['format']" [form]="quoteForm" [bSubmitted]="bSubmitted" strMode="add" strModule="quotes"></app-edit-field>
          </div>

          <div class="col-lg-3 mt-3">
            <app-edit-field [item]="objQuotesField['quote_date']" [form]="quoteForm" [bSubmitted]="bSubmitted" strMode="add" strModule="quotes"></app-edit-field>
          </div>

          <div class="col-lg-3 mt-3">
            <app-edit-field [item]="objQuotesField['expiry_date']" [form]="quoteForm" [bSubmitted]="bSubmitted" strMode="add" strModule="quotes"></app-edit-field>
          </div>

          <div
            fieldmagicGridColumn="12"
            class="mt-3"
          >
            <div class="form-group">
              <label style="font-size: 14px" class="d-flex align-items-center">
                {{ 'quote_summary' | translate }} <span class="text-danger ml-1">*</span>
                <button
                  class="ql-magic ml-2"
                  (click)="onShowPromptSelector('summary')"
                  [disabled]="(summaryInProgress$ | async)"
                  matTooltip="Generate summary"
                  matTooltipClass="system-tooltip"
                  matTooltipPosition="above"
                > <!-- Added for AI Quote Summary Loading State Button -->
                  <fieldmagic-icon *ngIf="!(summaryInProgress$ | async)" icon="magic" class="text-primary" style="font-size: 12px;"></fieldmagic-icon>
                  <fieldmagic-icon *ngIf="(summaryInProgress$ | async)" icon="spinner" [spin]="true" class="text-primary" style="font-size: 12px;"></fieldmagic-icon>

                </button>
              </label>
              <textarea
                class="form-control"
                [class.is-invalid]="quoteForm.get('quote_summary') && !quoteForm.get('quote_summary').valid && (quoteForm.get('quote_summary').touched || bSubmitted)"
                formControlName="quote_summary"
                rows="4"
                maxlength="10000"
                style="min-height: 80px; resize: vertical;"
              ></textarea>
              <div *ngIf="quoteForm.get('quote_summary') && !quoteForm.get('quote_summary').valid && (quoteForm.get('quote_summary').touched || bSubmitted)" class="invalid-feedback">
                <span *ngIf="quoteForm.get('quote_summary') && quoteForm.get('quote_summary').errors && (quoteForm.get('quote_summary').errors['required'] || quoteForm.get('quote_summary').errors['incorrect'])">{{ 'field_required' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="col-12 mt-4">
            <div class="d-flex">
              <div class="flex-grow-1">
                <browse-products
                  [strPricebookId]="strPricebookId"
                  (objProductSelected)="addAttribute($event, false)"
                  (objGroupSelected)="addGroup($event)"
                  [overrideUnitPriceWithDiscountPrice]="false"
                  [bHasAssetType]="true"
                  [strContractId]="strContractId"
                >
                </browse-products>
              </div>
              <div class="ml-2">
                <button class="btn btn-primary h-40 mr-2" (click)="addGroup()">
                  <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>&nbsp;{{ 'add_group' | translate }}
                </button>
                <button class="btn btn-info h-40" (click)="getRelatedProducts(true)">
                  <fa-icon [icon]="['fas', 'sync-alt']"></fa-icon>&nbsp;{{ 'reset_pricing' | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="col-lg-12 mt-2">
            <table class="table border-left border-right border-bottom" style="table-layout: fixed;">
              <thead>
                <tr>
                  <th scope="col" width="7%"></th>
                  <th scope="col" >{{ 'description' | translate }}<required-tag></required-tag></th>
                  <!-- FC-4611: Make department field required -->
                  <th *ngIf="bDepartmentTracking" scope="col" width="12%">{{ 'department' | translate }}<required-tag></required-tag></th>
                  <th scope="col" width="7%">{{ 'quantity' | translate }}</th>
                  <th scope="col" width="7%">{{ 'cost' | translate }}</th>
                  <th scope="col" width="7%">{{ 'unit_price' | translate }}</th>
                  <th
                    *fieldmagicIsConfigured="'enable_discounts'"
                    scope="col" width="7%"
                  >
                    {{ 'discounted_price' | translate }}
                  </th>
                  <th scope="col" width="7%">{{ 'markup' | translate }}</th>
                  <th scope="col" width="12%">{{ 'tax_code' | translate }}<required-tag></required-tag></th>
                  <th scope="col" width="13%" class="text-center">{{ 'line_total' | translate }}</th>
                </tr>
              </thead>
              <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                <tr *ngIf="arLineItems.length === 0" [shAttachMenu]="contextMenuComponent?.menu" [shMenuData]="contextMenuService.formatMenuData([], -1)">
                  <td [attr.colspan]="groupRowColspan" align="center">
                    <div class="row p-2 m-2">
                      <div class="col-12 text-center">{{ 'empty_quote_label' | translate }}</div>
                    </div>
                  </td>
                </tr>
                <ng-container *ngFor="let attr of arLineItems; index as numLineItemIndex">

                  <ng-container
                    *ngIf="checkIfGroup(attr); then isGroupItem; else isLineItem">
                  </ng-container>

                  <ng-template #isGroupItem>
                    <tr
                      cdkDrag
                      [ngClass]="{
                        'multiple-selected': contextMenuService.isLineItemSelected(attr, selectedLineItems),
                        'row-focused': (numLastFocusedIndex - 1) == numLineItemIndex
                      }"
                    >
                      <td
                        [shAttachMenu]="contextMenuComponent?.menu"
                        [shMenuData]="contextMenuService.formatMenuData(attr, numLineItemIndex)"
                        (click)="onClickedLineItem($event, attr)"
                        matTooltip="{{ 'copy_paste_info' | translate }}"
                        matTooltipPosition="right"
                      >
                        <div class="d-flex flex-row">
                          <fa-icon cdkDragHandle
                            style="cursor: grab;"
                            class="p-2 pl-3"
                            [icon]="['fas', 'grip-vertical']">
                          </fa-icon>
                          <fa-icon (click)="removeAttribute(numLineItemIndex)"
                            class="pl-1 pr-1 pb-2 pt-2 text-danger pointer"
                            [icon]="['fal', 'minus-circle']">
                          </fa-icon>
                          <fa-icon
                            *ngIf="attr.item_id"
                            class="pl-1 pr-1 pb-2 pt-2 pointer"
                            [icon]="['fas', 'info-circle']">
                          </fa-icon>
                        </div>
                      </td>
                      <td [attr.colspan]="groupRowColspan">
                        <div class="p-2">
                          <input
                            type="text"
                            [ngClass]="{'is-invalid': (!attr['label']) && isTouched}"
                            [(ngModel)]="attr.label"
                            (ngModelChange)="markAsDirty()"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="{{ 'enter_group_title' | translate }}"
                            [class]="'form-control font-size-12'"
                            (focus)="setLastIndex(numLineItemIndex)"
                          />
                        </div>
                      </td>

                      <div *cdkDragPreview class="container-fluid bg-light p-0 m-0" style="width: 90%;">
                        <table class="table border-left border-right border-bottom m-0">
                          <tbody>
                            <tr>
                              <td scope="col" width="4%">
                                <fa-icon class="p-2 pl-3" cdkDragHandle [icon]="['fas', 'grip-vertical']"></fa-icon>
                              </td>
                              <td scope="col">
                                <div class="p-3">
                                  {{ attr.label || 'No Group Label' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          </table>
                      </div>
                    </tr>
                  </ng-template>

                  <ng-template #isLineItem>
                    <tr *ngIf="arLineItems.length == 0">{{ 'no_results' | translate }}</tr>
                    <tr
                      cdkDrag
                      [ngClass]="{
                        'multiple-selected': contextMenuService.isLineItemSelected(attr, selectedLineItems),
                        'row-focused': (numLastFocusedIndex - 1) == numLineItemIndex
                      }"
                    >
                      <td scope="col"
                        [shAttachMenu]="contextMenuComponent?.menu"
                        [shMenuData]="contextMenuService.formatMenuData(attr, numLineItemIndex)"
                        (click)="onClickedLineItem($event, attr)"
                        matTooltip="{{ 'copy_paste_info' | translate }}"
                        matTooltipPosition="right"
                      >
                        <div class="d-flex flex-row">
                          <fa-icon cdkDragHandle
                            style="cursor: grab;"
                            class="p-2  pl-3"
                            [icon]="['fas', 'grip-vertical']">
                          </fa-icon>
                          <ng-container *ngIf="attr.module == 'asset_types'; else itemDetails">
                            <a
                              href="/#/admin/asset_types/{{ attr.asset_type_id }}"
                              class="pl-1 pr-1 pb-2 pt-2 "
                              target="_blank">
                              <fa-icon
                                matTooltipClass="tooltip-space"
                                matTooltip="{{ 'show_asset_type' | translate }}"
                                class="text-primary"
                                [icon]="['fas', 'info-circle']">
                              </fa-icon>
                            </a>
                          </ng-container>
                          <ng-template #itemDetails>
                            <a *ngIf="attr.item_id"
                              href="/#/items/{{ attr.item_id }}"
                              class="pl-1 pr-1 pb-2 pt-2"
                              target="_blank">
                              <fa-icon
                                matTooltipClass="tooltip-space"
                                matTooltip="
                                {{ 'click_to_view' | translate }}&#13;&#13;
                                {{ 'product' | translate }}: {{ attr['item_name'] }}&#13;
                                {{ 'code' | translate }}: {{ attr['item_code'] | placeholdWithString }}&#13;
                                {{ 'preferred_supplier' | translate }}: {{ attr['preferred_supplier_text'] | placeholdWithString }}&#13;
                                {{ 'current_stock_level' | translate }}: {{ attr['current_stock_level'] }}"
                                class="text-primary"
                                [icon]="['fas', 'info-circle']">
                              </fa-icon>
                            </a>
                            <fa-icon *ngIf="attr.item_id"
                              [icon]="['fas', 'chart-line']"
                              class="text-primary desktop-container pointer pl-1 pr-1 pb-2 pt-2"
                              matTooltip="{{ 'show_stock_levels_and_supplier_pricing' | translate }}"
                              (click)="openSupplierInventoryDialog(attr.item_id)"
                            >
                            </fa-icon>
                            <fa-icon
                              *ngIf="!attr.item_id"
                              class="pl-1 pr-1 pb-2 pt-2 text-success pointer"
                              matTooltip="{{ 'create_item' | translate }}"
                              [icon]="['fas', 'plus-circle']"
                              (click)="createItem(attr)">
                            </fa-icon>
                          </ng-template>
                          <fa-icon (click)="removeAttribute(numLineItemIndex)"
                            class="pl-1 pr-1 pb-2 pt-2 text-danger pointer"
                            [icon]="['fal', 'minus-circle']">
                          </fa-icon>
                          <fa-icon
                            *ngIf="attr.related_products.length > 0"
                            matTooltip="{{ 'add_related_products' | translate }}"
                            class="pl-1 pr-1 pb-2 pt-2 pointer text-success"
                            [icon]="['fas', 'plus-circle']"
                            (click)="addRelated(attr, numLineItemIndex)">
                          </fa-icon>
                        </div>
                      </td>
                      <td scope="col">
                        <div class="p-2">
                          <textarea
                            class="form-control h-40"
                            rows="1"
                            style="font-size: 12px;"
                            placeholder="{{ 'description' | translate }}"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="attr['description']"
                            [ngClass]="{'is-invalid': !attr['description'] && isTouched}"
                            (ngModelChange)="markAsDirty()"
                            (focus)="expandInput($event.target); setLastIndex(numLineItemIndex);"
                            (focusout)="shrinkInput($event.target);"></textarea>
                        </div>
                      </td>
                      <!-- FC-4611: Make department field required -->
                      <td *ngIf="bDepartmentTracking" scope="col">
                        <div class="p-2">
                          <ng-select
                            [items]="objDepartmentObv[attr.id].source | async"
                            [addTag]="addTag"
                            [typeahead]="objDepartmentObv[attr.id].typehead"
                            [loading]="objDepartmentObv[attr.id].loader"
                            [hideSelected]="true"
                            [clearable]="true"
                            [ngModelOptions]="{standalone: true}"
                            bindLabel="text"
                            [bindValue]="'id'"
                            placeholder="{{ 'department' | translate }}"
                            [(ngModel)]="attr.department_id"
                            [id]="attr['id'] + 'department'"
                            [name]="attr['id'] + 'department'"
                            (change)="selectADepartment($event, numLineItemIndex)"
                            class="h-40"
                            [ngClass]="{'is-invalid': !attr.department_id && isTouched}"
                            (focus)="setLastIndex(numLineItemIndex)">
                          </ng-select>
                        </div>
                      </td>
                      <td scope="col">
                        <div class="p-2">
                          <fieldmagic-decimal-input
                            (focus)="setLastIndex(numLineItemIndex)"
                            customClass="form-control input-height-40 font-size-12"
                            placeholder="{{ 'quantity' | translate }}"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="attr['quantity']"
                            [ngClass]="{'is-invalid': !checkQuantity(attr['quantity']) && isTouched}"
                            (ngModelChange)="markAsDirty()"
                            (change)="isProfitIncreased()"
                            disableScroll
                          ></fieldmagic-decimal-input>
                        </div>
                      </td>
                      <td scope="col">
                        <div class="p-2">
                          <fc-currency-input
                            (focus)="setLastIndex(numLineItemIndex)"
                            [places]="4"
                            customClass="form-control input-height-40 font-size-12"
                            placeholder="{{ 'hourly_cost' | translate }}"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="(attr['labor']) ? attr['hourly_cost'] : attr['unit_cost']"
                            (ngModelChange)="(attr['labor']) ? (attr['hourly_cost'] = $event) : (attr['unit_cost'] = $event)"
                            (change)="onUnitCostChange($event, numLineItemIndex)"
                            disableScroll
                          ></fc-currency-input>
                        </div>
                      </td>
                      <td scope="col"  *ngIf="attr['label'] === undefined">
                        <div class="p-2">
                          <fc-currency-input
                            [places]="4"
                            id="unit_price_{{ numLineItemIndex }}"
                            [(ngModel)]="attr['unit_price']"
                            [ngModelOptions]="{standalone: true}"
                            [customClass]="'form-control font-size-12 input-height-40'"
                            (focusout)="onUnitPriceChange(attr);"
                            (focus)="setLastIndex(numLineItemIndex)"
                            (ngModelChange)="markAsDirty()"
                            (change)="isProfitIncreased(); adjustMarkup(numLineItemIndex)"
                            disableScroll
                          >
                          </fc-currency-input>
                        </div>
                      </td>
                      <td
                        *fieldmagicIsConfigured="'enable_discounts'"
                        scope="col"
                      >
                        <div class="p-2">
                          <fc-currency-input
                            [places]="4"
                            id="discounted_price_{{ numLineItemIndex }}"
                            [(ngModel)]="attr['discounted_price']"
                            [ngModelOptions]="{standalone: true}"
                            [customClass]="'form-control font-size-12 input-height-40'"
                            (focus)="setLastIndex(numLineItemIndex)"
                            (ngModelChange)="markAsDirty()"
                            (change)="isProfitIncreased();"
                            disableScroll
                          >
                          </fc-currency-input>
                        </div>
                      </td>
                      <td scope="col" *ngIf="attr['label'] === undefined || attr['label'] === null">
                        <div class="p-2">
                          <fieldmagic-decimal-input
                            (focus)="setLastIndex(numLineItemIndex)"
                            (change)="markupChange($event, numLineItemIndex)"
                            customClass="form-control input-height-40 font-size-12"
                            placeholder="{{ 'markup' | translate }}"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="attr['markup']"
                            disableScroll>
                          </fieldmagic-decimal-input>
                        </div>
                      </td>
                      <td scope="col">
                        <div class="p-2">
                          <ng-select
                            (focus)="setLastIndex(numLineItemIndex)"
                            [items]="arTaxCodes"
                            [hideSelected]="true"
                            [clearable]="true"
                            (change)="selectATaxcode($event, numLineItemIndex)"
                            [ngModelOptions]="{standalone: true}"
                            bindLabel="text"
                            bindValue="id"
                            appendTo="body"
                            placeholder="{{ 'tax_code' | translate }}"
                            [(ngModel)]="attr.tax_code_id"
                            [id]="attr['id'] + 'tax'"
                            [name]="attr['id'] + 'tax'"
                            class="h-40"
                            [ngClass]="{'is-invalid': (!attr['tax_code_id']) && isTouched}">
                          </ng-select>
                        </div>
                      </td>

                      <td scope="col"
                        [shAttachMenu]="contextMenuComponent?.menu"
                        [shMenuData]="contextMenuService.formatMenuData(attr, numLineItemIndex)"
                        (click)="onClickedLineItem($event, attr)"
                        matTooltip="{{ 'copy_paste_info' | translate }}"
                        matTooltipPosition="right"
                      >
                        <div class="text-center"
                        matTooltip="{{ 'line_total' | translate }} - {{ 'cost' | translate }} = {{ 'profit' | translate }} &#13;
                        {{ attr.computeLineItem | currency }} - {{ computeCostPerLineItem(attr) | currency }} = {{ computeProfitPerLineItem(attr) | currency }}"
                        matTooltipClass="profit-tooltip">
                          {{ attr.computeLineItem | currency }}
                        </div>
                      </td>

                      <div *cdkDragPreview class="container-fluid bg-light p-0 m-0" style="width: 90%;">
                        <table class="table border-left border-right border-bottom m-0">
                          <tbody>
                            <tr>
                              <td scope="col" width="4%"><fa-icon class="p-2 pl-3" cdkDragHandle [icon]="['fas', 'grip-vertical']"></fa-icon></td>
                              <td scope="col" width="20%"><div class="p-2">{{ attr['description'] | slice:0:75 }}</div></td>
                              <td scope="col" width="13%"><div class="p-2">{{ attr['department_name'] }}</div></td>
                              <td scope="col" width="10%"><div class="p-2">Qty. {{ attr['quantity'] }}</div></td>
                              <td scope="col" width="10%"><div class="p-2">{{ attr['unit_price'] | currency }}</div></td>
                              <td
                                *fieldmagicIsConfigured="'enable_discounts'"
                                scope="col"
                                width="10%"
                              >
                                <div class="p-2">
                                  {{ attr['discounted_price'] | currency }}
                                </div>
                              </td>
                              <td scope="col" width="13%"><div class="p-2">{{ attr['tax_code_name'] }}</div></td>
                              <td scope="col" width="10%"><div class="p-2">{{ ((attr['labor']) ? attr['hourly_cost'] : attr['unit_cost']) | currency }}</div></td>
                              <td scope="col" width="10%"><div class="p-2">{{ attr.computeLineItem | currency }}</div></td>
                            </tr>
                          </tbody>
                          </table>
                      </div>

                    </tr>
                  </ng-template>

                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="col-lg-12 mt-1">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th scope="row" width="70%" class="invisible"></th>
                  <td scope="row" width="12%" ><span class="p-3 float-right">{{ 'total_ex_tax' | translate }}</span></td>
                  <td scope="row" width="12%" class="text-center"><span class="p-2">{{ totalWithoutTax | currency }}</span></td>
                </tr>
                <tr>
                  <th scope="row" class="invisible"></th>
                  <td scope="row"><span class="p-3 float-right">{{ 'profit_margin' | translate }}</span> </td>
                  <td scope="row" class="text-center"><span class="p-2" [ngClass]="(increasedProfit) ? 'text-success' : 'text-danger'">{{ totalProfit | currency }} ({{ profitPercentage }}%)</span></td>
                </tr>
                <tr>
                  <th scope="row" class="invisible"></th>
                  <td scope="row"><span class="p-3  float-right">{{ 'tax' | translate }}</span> </td>
                  <td scope="row" class="text-center"><span class="p-2">{{ totalTax | currency }}</span></td>
                </tr>
                <tr >
                  <th scope="row" class="invisible"></th>
                  <td scope="row"><span class="p-3  float-right">{{ 'total_inc_tax' | translate }}</span> </td>
                  <td scope="row" class="text-center"><span class="p-2">{{ totalWithTax | currency }}</span> </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="tab-pane fade" id="cover-letter" role="tabpanel" aria-labelledby="cover-letter-tab">
        <div class="mt-2">
          <!-- FC-4847: Make cover letter field draggable -->
          <quill-editor
            #quill
            id="cover-letter"
            formControlName="cover_letter"
            placeholder="Enter Text"
            [modules]="quillConfig"
            (onFocus)="onQuillFocus($event)">
            <div quill-editor-toolbar>
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-strike"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-code-block"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
              </span>
              <span class="ql-formats">
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="small"></option>
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
              </span>
              <span class="ql-formats">
                <select class="ql-header">
                  <option value="1"></option>
                  <option value="2"></option>
                  <option value="3"></option>
                  <option value="4"></option>
                  <option value="5"></option>
                  <option value="6"></option>
                  <option selected></option>
                </select>
              </span>
              <span class="ql-formats">
                <select class="ql-font"></select>
              </span>
              <span class="ql-formats">
                <select class="ql-align"></select>
              </span>
              <span class="ql-formats">
                <button class="ql-link"></button>
              </span>
              <span class="ql-formats">
                <button (click)="addDynamicVariables()" style="height: 45px;"
                 matTooltip="Add dynamic variables">&#123;&#125;</button>
              </span>
              <span class="ql-formats">
                <button
                  (click)="onShowPromptSelector('cover_letter')"
                  style="height: 45px;"
                  matTooltip="Generate with AI"
                  [disabled]="coverInProgress$ | async">
                  <!-- Added for AI Quote Cover Letter Loading State Button -->
                  <fieldmagic-icon *ngIf="!(coverInProgress$ | async)" icon="magic" style="font-size: 12px;"></fieldmagic-icon>
                  <fieldmagic-icon *ngIf="(coverInProgress$ | async)" icon="spinner" [spin]="true" style="font-size: 12px;"></fieldmagic-icon>
                </button>
              </span>
              <span class="ql-formats">
                <div class="dynamic-variables-container"
                    [class.show]="showDynamicVariables"
                    id="related-field-container">
                  <fieldmagic-related-field
                    #dropdownInput
                    [moduleName]="'opportunities'"
                    [variableMapping]="variableMapping"
                    [isOpen]="isOpen"
                    (closeVar)="showDynamicVariables = false; isOpen = false;"
                    (fieldChange)="onRelatedFieldChange($event)">
                  </fieldmagic-related-field>
                </div>
              </span>
            </div>
          </quill-editor>
        </div>
      </div>

      <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">

        <div class="add-item-container" *fcMinSubscriptionPlanRequired="'fieldmagic-advanced'">
          <span class="add-item" (click)="addDocument()" >
            <fa-icon [icon]="['fal', 'plus-circle']" ></fa-icon>
            {{ 'add_document_from_library' | translate }}
          </span>
        </div>

        <div class="order-contents" cdkDropList (cdkDropListDropped)="dropDocument($event)">
          <div  *ngFor="let document of arDocumentList index as i" class="drag-item" cdkDrag>
            <input *ngIf="document['document_name'] != 'quote_content'" type="checkbox" class="checkbox-order" [(ngModel)]="document['is_included']" [ngModelOptions]="{standalone: true}" [disabled]="document['disabled']">
            {{ document.document_name | translate }}
            <fa-icon class="drag-icon" [icon]="['fas', 'arrows-alt']" rotate="45"></fa-icon>
            <fa-icon *ngIf="document.document_name != 'quote_content'" class="remove-icon" [icon]="['fal', 'minus-circle']" (click)="removeDocument(document.id)"></fa-icon>
          </div>

          <div class="file-drop-container" *fcMinSubscriptionPlanRequired="'fieldmagic-advanced'">

            <input class="file-input" type="file" (change)="onFileChange($event)" accept="application/pdf"/>

            <div *ngIf="!isFileDropped && arFiles.name == undefined" class="file-input-overlay">
              {{ 'drop_pdf_file' | translate }}
            </div>

            <div *ngIf="isFileDropped" class="file-input-overlay-uploading">
              <fa-icon [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon> {{ 'uploading' | translate }}
            </div>

            <div *ngIf="!isFileDropped && arFiles.name !== undefined" class="file-input-overlay-uploaded">
              {{ 'drop_pdf_file' | translate }}
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
</ng-container>
<fc-context-menu (isClicked)="doSomethingFromContextMenu($event)"></fc-context-menu>

<!-- AI Prompt Selector Modal -->
<div class="ai-prompt-modal" *ngIf="showPromptSelector">
  <div class="ai-prompt-overlay" (click)="closePromptSelector()"></div>
  <div class="ai-prompt-content">
    <div class="ai-prompt-header">
      <h5>{{ currentAIMode === 'summary' ? ('Generate Quote Summary with AI' | translate) : ('Generate with AI' | translate) }}</h5>
      <button type="button" class="btn btn-danger btn-sm close-btn-system" (click)="closePromptSelector()">
        <fa-icon [icon]="['fas','times']"></fa-icon>
        <span class="pl-1">{{ 'close' | translate }}</span>
      </button>
    </div>
    <div class="ai-prompt-body">
      <div class="prompt-list">
        <div class="prompt-item" *ngFor="let p of arAvailablePrompts" (click)="onSelectPrompt(p)">
          <div class="prompt-name">{{ p.strLabel }}</div>
          <div class="prompt-description">{{ p.strDescription || (p.strPromptTemplate | slice:0:120) }}</div>
        </div>
        <div *ngIf="arAvailablePrompts.length === 0" class="text-muted small">
          {{ 'no_available_prompt' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!bDialogLoaded">
  <div class="col-sm-12" align="center">
    <h4><fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon></h4>
  </div>
</ng-container>
